import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	isCustomActionEndpointUrlAccessible,
	isCustomActionEndpointUrlAccessibleEndpoint,
	type QueryError,
	type IsCustomActionEndpointUrlAccessibleResult,
	type IsCustomActionEndpointUrlAccessibleRequestOptions,
} from '../isCustomActionEndpointUrlAccessible';
export * from '../isCustomActionEndpointUrlAccessible';

export type IsCustomActionEndpointUrlAccessibleQueryParams =
	IsCustomActionEndpointUrlAccessibleRequestOptions;

export type IsCustomActionEndpointUrlAccessibleQueryKey = [
	string,
	IsCustomActionEndpointUrlAccessibleQueryParams,
];

export type IsCustomActionEndpointUrlAccessibleQueryOptions = Omit<
	UseQueryOptions<
		IsCustomActionEndpointUrlAccessibleResult,
		QueryError,
		IsCustomActionEndpointUrlAccessibleResult,
		IsCustomActionEndpointUrlAccessibleQueryKey
	>,
	'queryKey' | 'queryFn'
>;

/**
 * react-query wrapper for `isCustomActionEndpointUrlAccessible`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryIsCustomActionEndpointUrlAccessible = (
	queryKeyParams: IsCustomActionEndpointUrlAccessibleQueryParams,
	options?: IsCustomActionEndpointUrlAccessibleQueryOptions,
) =>
	useQuery<
		IsCustomActionEndpointUrlAccessibleResult,
		QueryError,
		IsCustomActionEndpointUrlAccessibleResult,
		IsCustomActionEndpointUrlAccessibleQueryKey
	>({
		queryKey: [isCustomActionEndpointUrlAccessibleEndpoint, queryKeyParams],
		queryFn: ({queryKey, signal}) =>
			isCustomActionEndpointUrlAccessible({...queryKey[1]}, signal),
		...options,
	});

export default useReactQueryIsCustomActionEndpointUrlAccessible;
